/**
 * views/index.js
 */
export {default as Overview} from './overview/OverviewView';
export {default as Settings} from './settings/SettingsView';
export {default as SignUp} from './signup/SignUpView';
export {default as NewTerms} from './new-terms/NewTermsView';
export {default as CloseAccount} from './close-account/CloseAccountView';
export {default as Payout} from './payout/PayoutView';
export {default as Dashboard} from './dashboard/DashboardView';
export {default as News} from './news/NewsView';
export {default as Article} from './news/ArticleView';
export {default as FortniteGames} from './fortnite-games/FortniteGamesView';
export {default as OAuthView} from './popup/OAuthView';
export {default as EulaView} from './eula/EulaView';
export {default as Reactivate} from './reactivate/ReactivateView';
